<template>

  <Tables class="Table-Info" ref="tableGrids"
      :columns="head"
      style="font-family:'Segoe UI'"
      :showSearch="false"
      :showPrint="false"
      :showDownload="false"
      :showFullscreen="false"
      v-on:Load="onLoad"
    >
      <tr v-for="data in dataInfo" v-bind:key="data.id">
          <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.nome" />
          <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.countEmpreendimento" />
          <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.countCorretor" />
          <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.countAdministrador" />
          <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.cidade.nome" />
          <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.cidade.estado.sigla" />
          <TableColumn :newState="true" :colorStatus="['#30A75F', '#DB3939'][data.situacao]" :descriptionNewStatus="['Ativo','Inativo'][data.situacao]"  />
          <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.dataCadastroFormatada" />
          <TableColumn :IsActionsButtons="true" slot-scope="" v-on:Change="onChange(data)" v-on:Delete="$emit('deleteAccredited', data)" v-on:Edit="$emit('edit')" :status="data.situacao" />
      </tr>
    </Tables>

</template>

<script>
import Tableaccredited from './tableaccredited'
export default Tableaccredited

</script>

<style scoped>

.Table-Info{
  width: 128%;
}

 @media screen and (max-width: 1600px) {
 .Table-Info{
  width: 128%;
 }
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/accredited/components/tableaccredited/tableaccredited.vue